import {Component, OnInit} from '@angular/core';
import {WishlistService} from "../../services/wishlist.service";
import {Wishlist} from "../../models/Wishlist/Wishlist";
import {Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';


@Component({
    selector: 'app-wishlist',
    templateUrl: './wishlist.component.html',
    styleUrls: ['./wishlist.component.css']
})
export class WishlistComponent implements OnInit {



    wishlist: Wishlist = null;
    isLoading = true;

    constructor(
        private wishlistService: WishlistService , private router: Router , private snackBar: MatSnackBar
    ) {
    }

    ngOnInit(): void {

        this.getWishlist();
    }

    getWishlist() {




        this.wishlistService.getCustomerWishlist().subscribe(wishlist => {

            this.wishlist = wishlist;
            this.isLoading = false;



        });

    }

    goToProductDetails(sku) {
        this.router.navigateByUrl('product/details/' + sku);


    }

    deleteItemFromWishlist(item) {
        let obj = {
            "id" : item.id,
            "product" : item.product,
        }
        const index = this.wishlist.items.findIndex(object => {
            return object.product.sku === obj.product.sku;
        });

        //console.log(index);return;
        //
        // this.wishlistService.removeWishlistItem(item.product.sku).subscribe(result => {
        //     this.wishlist.items.splice(index , 1) ;
        //     this.openSuccessSnackBar('The item removed from the WishList successfully', 'OK');
        //
        // });

        let customer = JSON.parse(localStorage.getItem('current_customer'));
        this.wishlistService.removeWishlistItem2(customer.id,item.id).subscribe(result => {
            this.wishlist.items.splice(index , 1) ;
            this.openSuccessSnackBar('The item removed from the WishList successfully', 'OK');

        });
    }

    // Snackbar that opens with success background
    openSuccessSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 3000,
            horizontalPosition: 'right',
            panelClass: ['primary-snackbar'],
        });
    }

}
